/**
 * Formats an array of strings into a single, comma separated string with `$conjunction` before on last two items.
 *
 * Example 1
 * Input: (['Basic', 'Essentials', 'Max'])
 * Output: 'Basic, Essentials and Max'
 *
 * Example 2
 * Input (['Basic', 'Essentials', 'Max'], '&')
 * Output: 'Basic, Essentials & Max'
 */
export const stringArrayToDisplayList = (input: string[], conjunction = 'and'): string =>
  input.join(', ').replace(/,([^,]*)$/, ` ${conjunction} $1`);
